<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">
      @if(isUpdatePage){
        تعديل شركة
      }
      @else{
        شركة جديدة
      }
    </h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="name"
              placeholder="{{ 'Name' | translate }}"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="name_ar"
              placeholder="الاسم بالعربي"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="specialty"
              placeholder="التخصص"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="industry"
              placeholder="القطاع"
            />
          </div>

          <!-- Location -->
          <div class="form-group dropdown-container">
            <select formControlName="country_id" (change)="onCountryChange()">
              <option [ngValue]="null">اختر الدولة</option>

              <option *ngFor="let country of countries" [ngValue]="country.id">
                {{ country.country_name_ar }} - {{ country.country_name_en }}
              </option>
            </select>
          </div>

          <div class="form-group dropdown-container">
            <select formControlName="city_id" [disabled]="!data.get('country_id')?.value">
              <option [ngValue]="null">اختر المدينة</option>

              <option *ngFor="let city of cities" [ngValue]="city.id">
                {{ city.city_name_ar }} - {{ city.city_name_en }}
              </option>
            </select>
          </div>

          @if(!isUpdatePage){
            <div class="form-group">
              <input
                class="input"
                type="text"
                formControlName="tel"
                placeholder="تليفون"
              />
            </div>
          }

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="address"
              placeholder="{{ 'address' | translate }}"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="contact_email"
              placeholder="الايميل"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="facebook"
              placeholder="فيسبوك"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="linkedin"
              placeholder="انستجرام"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="fax"
              placeholder="فاكس"
            />
          </div>

          <div class="form-group">
            <input
              #fileInput
              class="input"
              type="file"
              accept="image/*"
              (change)="onFileSelected($event)"
            />
          </div>

          <div class="form-group checkbox">
            <label>
              <input
                type="checkbox"
                formControlName="is_ahmed_elshahat_client"
              />
              عميل أحمد الشحات
            </label>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="fromsave accont"
              [disabled]="data.invalid || isSubmitting"
            >
              @if(isSubmitting){
                جاري الحفظ...
              }
              @else if(isUpdatePage){
                {{ 'Edit' | translate }}
              }
              @else{
                {{ 'Create Client' | translate }}
              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>